import React from "react";
import {
  CheckCheck,
  Package,
  Tag,
  CalendarDays,
  Users,
  Wallet,
  Settings,
  CircleGauge,
  PencilLine,
  Globe,
  GlobeIcon,
} from "lucide-react";
import { Tooltip } from "react-tooltip";
import { MyTooltip } from "./MyTooltip";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../util/AppProvider";
import { Android, AndroidSharp, Web } from "@mui/icons-material";
export function AppCard({ onToggleHome, app, aKey, onEdit, onIcon }) {
  const navigate = useNavigate();
  const { setSelectedApp } = useAppContext();

  const openSettings = () => {
    setSelectedApp(app); // this triggers sidebar change
    if (typeof onToggleHome === "function") onToggleHome();
    // Navigate to global settings configs as requested
    navigate(`/apps/${app.name}/settings/configs`);
  };
  const openUsers = () => {
    setSelectedApp(app); // this triggers sidebar change
    // Navigate to global settings configs as requested
    navigate(`/apps/${app.name}/users`);
  };
  const openTrans = () => {
    setSelectedApp(app); // this triggers sidebar change
    // Navigate to global settings configs as requested
    navigate(`/apps/${app.name}/transactions`);
  };
  const openAnalytics = () => {
    setSelectedApp(app); // this triggers sidebar change
    // Navigate to global settings configs as requested
    navigate(`/apps/${app.name}/analytics`);
  };

  // const openApp = () => {
  //   setSelectedApp(app); // trigger sidebar to switch to app menu
  //   if (typeof onToggleHome === "function") onToggleHome();
  //   navigate(`/apps/${app.name}`);
  // };

  return (
    <div
      // onClick={openApp}
      key={aKey}
      className="bg-white/80 dark:bg-slate-900/80 backdrop-blur-xl rounded-2xl   
           hover:shadow-xl hover:shadow-slate-900/20 transition-all duration-300 group "
    >
      <div className="w-full px-4 pt-4 flex items-center justify-start space-x-4">
        {/* App icon */}
        <img
          onClick={() => onIcon(app.icon)}
          className="rounded-lg w-10 h-10 cursor-pointer"
          src={app.icon}
          alt="mangocash"
        />
        <h1 className="font-semibold text-sm text-slate-800 dark:text-white">
          {app.name}
        </h1>
        <div className="flex items-center justify-end space-x-2 ml-auto ">
          {(app.os == "android" && (
            <AndroidSharp className="text-green-500 w-4 h-4" />
          )) ||
            (app.os == "web" && (
              <GlobeIcon className="text-blue-500 w-5 h-5" />
            ))}
          <span className="text-xs text-green-500 rounded-full bg-green-100/20 px-2 py-0.6 border border-green-500/20">
            Active
          </span>
        </div>
      </div>
      {/* package */}
      <div className="flex items-center px-4 justify-start mt-5 ml-auto space-x-2">
        <Package className="w-4 h-4 text-slate-500 dark:text-white-200" />
        <span className="text-xs text-slate-500 dark:text-white-200">
          {app.package_name}
        </span>
      </div>
      {/* App Id */}
      <div className="flex items-center  px-4 justify-start mt-3 ml-auto space-x-2">
        <Tag className="w-4 h-4 text-slate-500 dark:text-white-200" />
        <span className="text-xs text-slate-500 dark:text-white-200">
          App ID:{app.id}
        </span>
      </div>
      {/* App Id */}
      <div className="px-4 flex items-center justify-start mt-3 ml-auto space-x-2">
        <CalendarDays className="w-4 h-4 text-slate-500 dark:text-white-200" />
        <div className=" w-full flex items-center justify-between ">
          <span className="text-xs text-slate-500 dark:text-white-200">
            {app.date_time}
          </span>
          <span className=" font-semibold text-xs text-black dark:text-white">
            v{app.version}
          </span>
        </div>
      </div>

      <div className="px-4 py-3 border-t border-state-200/50 dark:border-slate-700/50  mt-4 w-full backdrop-blur-xl bg-slate-400/20 dark:bg-slate-700/60 rounded-b-2xl  flex items-center justify-center">
        <div className="w-full flex items-center justify-between ">
          <div className="flex items-center justify-start space-x-2 ">
            <Users
              onClick={(e) => {
                localStorage.setItem("appToken", app.app_token); // set app token for user management
                e.stopPropagation();
                openUsers();
              }}
              data-tooltip-id="user-tt"
              className="w-8 h-8 p-2 
              hover:shadow-xl hover:shadow-slate-900/20 
               cursor-pointer
              border border-blue-400/40 text-blue-400 rounded-md bg-white/80 dark:bg-slate-900/80 "
            />
            <Wallet
              onClick={(e) => {
                localStorage.setItem("appToken", app.app_token); // set app token for transactions
                e.stopPropagation();
                openTrans();
              }}
              data-tooltip-id="trans-tt"
              className="w-8 h-8 p-2 border border-blue-400/40 text-green-400 rounded-md bg-white/80 dark:bg-slate-900/80 cursor-pointer"
            />
            <Settings
              onClick={(e) => {
                localStorage.setItem("appToken", app.app_token); // set app token for settings
                e.stopPropagation();
                openSettings();
                // onToggleHome
              }}
              data-tooltip-id="settings-tt"
              className="w-8 h-8 p-2 border border-blue-400/40 text-gray-400 rounded-md bg-white/80 dark:bg-slate-900/80  cursor-pointer"
            />
            <CircleGauge
              onClick={(e) => {
                localStorage.setItem("appToken", app.app_token); // set app token for settings
                e.stopPropagation();
                openAnalytics();
              }}
              className="w-8 h-8 p-2 border border-blue-400/40 text-blue-400 rounded-md bg-white/80 dark:bg-slate-900/80   cursor-pointer"
            />
          </div>
          <button
            onClick={(e) => {
              e.stopPropagation();
              if (typeof onEdit === "function") onEdit(app);
            }}
            data-tooltip-id="edit-tt "
            className="flex cursor-pointer items-center justify-center space-x-2 px-2 py-1.5  rounded-md border border-blue-400/40 bg-white/80 dark:bg-slate-900/80 text-xs font-semibold text-red-300 dark:text-red-300"
          >
            <PencilLine className="w-3 h-3" />
            <span>Edit</span>
          </button>
          <MyTooltip id="edit-tt" content="Edit this app" />
          <MyTooltip id="user-tt" content="Manage Users" />

          <MyTooltip id="trans-tt" content="Transactions" />

          <MyTooltip id="settings-tt" content="App Settings" />
        </div>
      </div>
    </div>
  );
}
